import { z } from 'zod'

export const metroPlusValidationSchema = z.object({
  representative: z
    .string()
    .refine(
      (value) => !value || z.email().safeParse(value).success,
      'Invalid email',
    ),
  confirm: z.boolean(),
})
